import { addHours, endOfDay, isSameDay, startOfDay } from "date-fns"

interface AvailabilitiesSearchQueryDate {
  selectedDay: Date | null
  currentFetchDate: Date
  isPsychologist: boolean
}

const PSYCHOLOGIST_QUERY_HOUR = 12
const PSYCHIATRIST_QUERY_HOUR = 1

export function searchQueryAvailabilitiesDate({ 
  selectedDay, 
  currentFetchDate, 
  isPsychologist 
}: AvailabilitiesSearchQueryDate) {

  const hoursToAddToSearchQuery = isPsychologist
    ? PSYCHOLOGIST_QUERY_HOUR
    : PSYCHIATRIST_QUERY_HOUR

  const startDate = selectedDay || currentFetchDate
  
  const currentMilliseconds = new Date().getTime()
  const currentTimeInStartDate = new Date(startDate)
  currentTimeInStartDate.setHours(new Date(currentMilliseconds).getHours())
  currentTimeInStartDate.setMinutes(new Date(currentMilliseconds).getMinutes())

  const startDateIsToday = isSameDay(startDate, new Date())

  const listProfessionalStartDate = startDateIsToday 
    ? addHours(currentTimeInStartDate, hoursToAddToSearchQuery)
    : startOfDay(startDate)

  const listProfessionalEndDate = startDateIsToday
    ? endOfDay(addHours(currentTimeInStartDate, hoursToAddToSearchQuery))
    : endOfDay(startDate)
  
  const startQueryDateISO = listProfessionalStartDate.toISOString()
  const endQueryDateISO = listProfessionalEndDate.toISOString()
  
  return { startQueryDateISO, endQueryDateISO }
}
